import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../../Icons/Icons";
import { useNavigate } from "react-router-dom";
import Papa from 'papaparse';


function ShowExcel2(props) {
  const { toggle, modal, setModal, navigatedFrom, fileSave } = props;
  console.log("navigatedFrom", navigatedFrom, fileSave);
  const [data, setData] = useState([]);


const handleFileChange = (e) => {
  const file = e?.target.files[0];
  const reader = new FileReader();
  reader.onload = function(event) {
    Papa.parse(event.target.result, {
      header: true,
      complete: (results) => {
        setData(results.data);
      }
    });
  };
  reader.readAsText(file);
};

useEffect(() => {
  console.log("sbshjbsjhsbjshb")
   if(fileSave){ const file = fileSave;
    const reader = new FileReader();
    reader.onload = function (event) {
      Papa.parse(event.target.result, {
        header: true,
        complete: (results) => {
          setData(results.data);
        },
      });
    };
    reader.readAsText(file);}
 }, [fileSave]);
  console.log("data......", data);


  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClose = () => {
    setModal(!modal);
  };

  // filesave has csv file exctract the data from it and show it in the table

  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width model-Radius"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <ModalBody
          className="transactionModalBody"
          //   style={{ marginTop: "25px" }}
        >
          <div className="closeBtnWithBackground" onClick={handleClose}>
            <SvgImage
              classname="close-btn-text"
              style={{ width: "10%", height: "10%" }}
              name="crossBtnWIthBackground"
              width="20%"
              height="20%"
            />
          </div>
          <div
            style={{ marginTop: " 30px" }}
            //   className="PGCollectionBox"
          >
            <div
              className="PGCollectiontText col-9"
              style={{ marginLeft: "50px" }}
            >
              Uploded sheet
            </div>
          </div>
          <div>
      
      <div>
  <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse' }}>
    <thead>
      <tr>
        <th style={{ borderBottom: '1px solid #000' }}>SL.no</th>
        <th style={{ borderBottom: '1px solid #000' }}>Phone</th>
        <th style={{ borderBottom: '1px solid #000' }}>Name</th>
        <th style={{ borderBottom: '1px solid #000' }}>BankAccount No.</th>
        <th style={{ borderBottom: '1px solid #000' }}>ifsc</th>
        <th style={{ borderBottom: '1px solid #000' }}>salary</th>
        {/* <th style={{ borderBottom: '1px solid #000' }}>last Salary</th> */}
      </tr>
    </thead>
    <tbody>
      {data.slice(0, -1).map((row, index) => (
       <tr key={index}>
  <td style={{ width: '10%', padding: '10px' }}>{index+1}</td>
  <td style={{ width: '17%', padding: '10px' }}>{row?.Phone}</td>
  <td style={{ width: '15%', padding: '10px' }}>{row?.Name}</td>
  <td style={{ width: '15%', padding: '10px' }}>{row?.BankAccountNo.replace(/["=]/g, '')}</td>
  <td style={{ width: '15%', padding: '10px' }}>{row?.IFSC}</td>
  <td style={{ width: '15%', padding: '10px' }}>{row?.Salary}</td>
  {/* <td style={{ width: '15%', padding: '10px' }}>{row?.LastSalaryAmount}</td> */}
</tr>
      ))}
    </tbody>
  </table>
</div>
    </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default ShowExcel2;
